<template>
  <div v-show="easySearchState.modalOpen" class="easySearch_modal">
    <div class="modalHeader">
      <div class="modalHeader_inner modal_layout">
        <button
          type="button"
          class="modalHeader_close"
          @click="easySearchModal.close"
        >
          <img src="@/assets/images/icon/close-main.svg" alt="" />
        </button>
      </div>
    </div>

    <div class="modal_layout">
      <div
        v-show="easySearchState.selectedButton === 'genre'"
        class="easySearch_modalBody"
      >
        <!-- <section class="section">
        <HeadingLv3
          text="あなたは医学部生、または初期研修医のうちどちらですか？"
        />
      </section> -->
        <section class="section">
          <HeadingLv3 text="研修先病院の種類はどちらを希望ですか？" />
          <FormRadioButtons
            name="hospitalType"
            :items="easySearchState.conditions.genre.hospital"
            :current-value="selectedConditions.cl"
            @change-value="checkHospital"
          />
        </section>
      </div>

      <div
        v-show="easySearchState.selectedButton === 'location'"
        id="easySearchModal"
        class="easySearch_modalBody"
      >
        <HeadingLv3 text="病院所在地を選ぶ" setLabelSlot
          ><span>＊複数選択可</span></HeadingLv3
        >
        <template v-for="(area, i) in areas" :key="i">
          <FormAreaCheckbox
            :id="`home_es_area${i}`"
            :label="area.name"
            :items="area.prefectures"
            @check-prefecture="checkPrefecture(i, $event)"
          />
        </template>
      </div>
    </div>

    <div class="easySearch_modalFooter">
      <GoalButtons>
        <Button
          v-if="easySearchState.selectedButton === 'genre'"
          label="病院所在地を選ぶ"
          :handleClick="
            () => {
              easySearchModal.change('location')
            }
          "
        />
        <Button
          v-if="easySearchState.selectedButton === 'location'"
          label="病院種別を選ぶ"
          :handleClick="
            () => {
              easySearchModal.change('genre')
            }
          "
        />
        <Button
          label="この条件で検索"
          :handleClick="easySearchModal.submit"
          primary
        />
      </GoalButtons>
    </div>
  </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { reactive } from 'vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import FormAreaCheckbox from '@/components/block/FormAreaCheckbox.vue'
import FormRadioButtons from '@/components/block/FormRadioButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'HomeEasySearchModal',

  components: {
    GoalButtons,
    FormAreaCheckbox,
    FormRadioButtons,
    HeadingLv3,
    Button
  },

  setup() {
    const router = useRouter()
    const store = useStore()

    type EasySearchStateTypes = {
      modalOpen: boolean
      selectedButton: 'genre' | 'location'
      conditions: {
        genre: {
          hospital: {
            label: string
            value: string
            id: string
          }[]
        }
      }
    }

    const easySearchState = reactive<EasySearchStateTypes>({
      modalOpen: false,
      selectedButton: 'genre',
      conditions: {
        genre: {
          hospital: [
            {
              label: '市中病院',
              value: '1',
              id: 'shityu'
            },
            {
              label: '大学病院',
              value: '2',
              id: 'daigaku'
            },
            {
              label: 'どちらも希望',
              value: '3',
              id: 'both'
            }
          ]
        }
      }
    })

    interface Pref {
      label: string
      value: string
      id: string
      area: string
      checked?: boolean
    }

    const areas: Array<any> = reactive([])
    const tempAreas: Array<string> = []
    const tempItems: Array<Pref> = []

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      tempAreas.push(el.area)

      const item: Pref = {
        label: el.option_name,
        value: el.opt_id,
        id: 'home_es_prefecture' + el.opt_id,
        area: el.area
      }
      tempItems.push(item)
    })

    const areaNames = Array.from(new Set(tempAreas))

    areaNames.forEach((area) => {
      const prefectures = tempItems.filter((item) => {
        return area === item.area
      })

      areas.push({
        name: area,
        prefectures: prefectures
      })
    })

    const selectedConditions = reactive<any>({
      pr: [],
      cl: ''
    })

    const checkPrefecture = (index: number, prefecture: any) => {
      areas[index].prefectures.forEach((item: Pref) => {
        if (prefecture.value === item.value) item.checked = prefecture.checked
      })

      if (
        prefecture.checked &&
        selectedConditions.pr.indexOf(prefecture.value) === -1
      ) {
        selectedConditions.pr.push(prefecture.value)
      }

      if (
        !prefecture.checked &&
        selectedConditions.pr.indexOf(prefecture.value) > -1
      ) {
        selectedConditions.pr.splice(
          selectedConditions.pr.indexOf(prefecture.value),
          1
        )
      }
    }

    const checkHospital = (value: string) => {
      selectedConditions.cl = value
    }

    const easySearchModal = {
      open: (selected: 'genre' | 'location') => {
        easySearchState.modalOpen = true
        easySearchState.selectedButton = selected
      },
      close: () => {
        easySearchState.modalOpen = false
      },
      change: (selected: 'genre' | 'location') => {
        easySearchState.selectedButton = selected
      },
      submit: () => {
        let url = '/search/hospital/list'

        if (selectedConditions.pr.length > 0) {
          url += '/pr_' + selectedConditions.pr.join('+')

          document.cookie = `searchAreaHome=${selectedConditions.pr[0]}; max-age=31536000; path=/`
        }

        if (selectedConditions.cl === '1' || selectedConditions.cl === '2') {
          url += '/cl_' + selectedConditions.cl
        } else if (selectedConditions.cl === '3') {
          url += '/cl_1+2'
        }

        router.push(url)
      }
    }

    return {
      easySearchState,
      easySearchModal,
      areas,
      selectedConditions,
      checkHospital,
      checkPrefecture
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.modal_layout {
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;

  @include mixins.media() {
    margin-right: auto;
    margin-left: auto;
    padding-right: 20px;
    padding-left: 20px;
    max-width: 752px;
  }
}

.easySearch_modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-top: 56px;
  padding-bottom: 100px;
  background-color: #fff;
  z-index: 9999;
  text-align: left;
}

.modalHeader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;

  &_inner {
    height: 56px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  &_close {
    position: absolute;
    right: 16px;
    top: 50%;
    margin-top: -9px;

    img {
      width: 18px;
      height: 18px;
    }
  }
}

.easySearch_modalBody {
  flex-grow: 1;

  .section:first-child {
    margin-top: 0;
  }
}

.easySearch_modalFooter {
  flex-shrink: 0;
  position: fixed;
  bottom: 0;
  width: 100%;

  .goalButtons {
    background-color: #fff;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.08);

    ::v-deep(.button) {
      height: 40px;
      margin: 0 6px;

      @include mixins.media() {
        margin: 0 8px;
      }
    }
  }
}
</style>
